<div>
    <ng-container *ngIf="loading">
        <ion-row class="ion-justify-content-center">
            <ion-col size="12">
                <div class="ion-text-center">
                    <ion-spinner name="lines"></ion-spinner>
                </div>
            </ion-col>
        </ion-row>
    </ng-container>
    <ng-container *ngIf="!loading">
        <ion-list lines="none" style="max-width: 900px; margin: auto">
            <!-- Contract For-Loop  -->
            <ion-item class="item-padding" *ngFor="let application of applicationContractList; let i = index">
                <div class="document-item-container">
                    <div class="document-item-left">
                        <ion-label><fa-icon [icon]="faFileSignature"></fa-icon> <span class="bold-text padding-left">Clinical Agreement</span></ion-label>
                        <p class="copy">Contract for {{ application?.name }}</p>
                    </div>
                    <div class="document-item-right">
                        <div class="upload-container">
                            <div>
                                <ion-button
                                    fill="clear"
                                    id="sign-contract-button-{{ i }}"
                                    color="dark-teal"
                                    class="upload-btn"
                                    (click)="openContract(application?.id, application?.contractapitoken, application?.signedcontract)"
                                >
                                    <fa-icon [icon]="faSignature"></fa-icon>
                                    Sign Contract
                                </ion-button>
                                <div>
                                    <ion-text
                                        (click)="openContract(application?.id, application?.contractapitoken, application?.signedcontract)"
                                        class="file-uploaded-text"
                                        *ngIf="application?.signedcontract"
                                    >
                                        <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                        <small>Contract Signed</small>
                                    </ion-text>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ion-item>
        </ion-list>
        <ion-list lines="none" style="max-width: 900px; margin: auto" *ngIf="showPreRequirements || showPostRequirements">
            <!-- Requirements For-Loop -->
            <ion-item class="item-padding" *ngFor="let requirement of requirementsList; let i = index">
                <div class="document-item-container">
                    <div class="document-item-left">
                        <ion-label class="ion-text-wrap">
                            <fa-icon [icon]="faFile"></fa-icon>
                            <span class="bold-text padding-left">{{ requirement?.jsondata?.name }}</span>
                        </ion-label>
                        <!-- ========== Requirement Description Case ========== -->
                        <div [ngSwitch]="requirement?.jsondata?.type">
                            <div *ngSwitchCase="'resume'">
                                <p class="copy">This document is a summary of your academic milestones and achievements.</p>
                                <div class="document-note">
                                    <div class="document-note-icon-container">
                                        <fa-icon [icon]="faInfoCircle"></fa-icon>
                                    </div>
                                    <div class="overflow-auto">
                                        <span class="copy"> Have questions about your CV/resume? </span>
                                        <br />
                                        <span class="copy">
                                            <a href="{{ (toolService.content | async)?.basic?.documents?.resumeguide }}">Read our documentation</a>
                                            and
                                            <a href="{{ (toolService.content | async)?.basic?.documents?.resumesample }}">view an example</a>.
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div *ngSwitchCase="'education'">
                                <p class="copy">This document certifies your attendance/completion at your educational institution in good standing.</p>
                            </div>
                            <div *ngSwitchCase="'english'">
                                <p class="copy">
                                    {{ (toolService.content | async)?.application?.components?.generalDocuments?.eligibility?.rightCardBottomContent }}
                                </p>
                            </div>
                            <div *ngSwitchCase="'visa'">
                                <p
                                    class="copy"
                                    [innerHTML]="
                                        (toolService.content | async)?.application?.components?.generalDocuments?.identity?.rightCardContent | safe: 'html'
                                    "
                                ></p>
                            </div>
                            <div *ngSwitchCase="'housing'">
                                <div
                                    *ngIf="requirement?.jsondata?.description"
                                    class="copy"
                                    [innerHTML]="requirement?.jsondata?.description | safe: 'html'"
                                ></div>
                                <div class="document-note">
                                    <div class="document-note-icon-container">
                                        <fa-icon [icon]="faInfoCircle"></fa-icon>
                                    </div>
                                    <div class="overflow-auto">
                                        <span class="copy">
                                            <ion-text color="primary" class="anchor-text" (click)="openHousingSuggestionsModal()">
                                                <p class="copy">
                                                    {{ (toolService.content | async)?.application?.components?.generalDocuments?.additional?.needhousing }}
                                                </p>
                                            </ion-text>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div *ngSwitchCase="'malpractice'">
                                <div
                                    class="copy"
                                    [innerHTML]="
                                        (toolService.content | async)?.application?.components?.generalDocuments?.health?.rightCardContentMalpractice
                                            | safe: 'html'
                                    "
                                ></div>
                            </div>
                            <div *ngSwitchCase="'passport'">
                                <div
                                    *ngIf="requirement?.jsondata?.description"
                                    class="copy"
                                    [innerHTML]="requirement?.jsondata?.description | safe: 'html'"
                                ></div>
                            </div>
                            <div *ngSwitchCase="'immune'">
                                <div class="copy" [innerHTML]="requirement?.jsondata?.description | safe: 'html'"></div>
                            </div>
                            <ng-container *ngSwitchCase="'healthInsurance'">
                                <div
                                    *ngIf="requirement?.jsondata?.description"
                                    class="copy"
                                    [innerHTML]="requirement?.jsondata?.description | safe: 'html'"
                                ></div>
                                <div class="document-note">
                                    <div class="document-note-icon-container">
                                        <fa-icon [icon]="faInfoCircle"></fa-icon>
                                    </div>
                                    <div class="overflow-auto">
                                        <span class="copy">
                                            <ion-text color="primary" class="anchor-text">
                                                <a
                                                    href="https://www.visitorscoverage.com/?utm_source=Affiliate&utm_campaign=VC_Affiliate"
                                                    target="_blank"
                                                    class="copy line-height-plus"
                                                >
                                                    {{ (toolService.content | async)?.application?.components?.generalDocuments?.health?.needinsurance }}
                                                </a>
                                            </ion-text>
                                        </span>
                                    </div>
                                </div>
                            </ng-container>

                            <div *ngSwitchDefault>
                                <div
                                    *ngIf="requirement?.jsondata?.description"
                                    class="copy"
                                    [innerHTML]="requirement?.jsondata?.description | safe: 'html'"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div class="document-item-right">
                        <div class="upload-container">
                            <div *ngIf="requirement?.programName">
                                <p class="copy ion-margin-bottom">For Program: {{ requirement?.programName }}</p>
                            </div>
                            <div>
                                <!-- ========== Requirement Upload Button ========== -->
                                <div [ngSwitch]="requirement?.jsondata?.type">
                                    <div *ngSwitchCase="'housing'"></div>
                                    <div *ngSwitchCase="'healthInsurance'">
                                        <div *ngFor="let application of applicationHealthInsurance; let i = index">
                                            <div class="ion-margin-bottom ion-margin-top">
                                                <p class="copy ion-no-margin">
                                                    For Program:
                                                    {{ application?.name }}
                                                </p>
                                            </div>
                                            <ion-button
                                                id="healthInsurance-upload-button-{{ i }}"
                                                fill="clear"
                                                color="dark-teal"
                                                class="upload-btn"
                                                (click)="
                                                    upload(
                                                        requirement?.jsondata?.type,
                                                        requirement?.applicationRequirementId,
                                                        requirement?.jsondata?.name,
                                                        i,
                                                        requirement?.level,
                                                        requirement?.levelid,
                                                        application.id
                                                    )
                                                "
                                            >
                                                <fa-icon [icon]="faUpload"></fa-icon>
                                                Upload Health Insurance
                                            </ion-button>
                                            <ng-container *ngFor="let document of application?.documents">
                                                <ion-text (click)="viewDocument(null, document.url)" class="file-uploaded-text" *ngIf="document.url">
                                                    <div class="ion-margin-bottom">
                                                        <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                                        <span class="copy">{{ document.filename | decodeFileUrl }} </span>
                                                    </div>
                                                </ion-text>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div *ngSwitchCase="'malpractice'">
                                        <!-- <div
                                            *ngFor="
                                                let application of handsOnApplications
                                            "
                                        >
                                            <ion-button
                                                *ngIf="!requirement?.Document.key"
                                                fill="clear"
                                                color="dark-teal"
                                                class="upload-btn"
                                                (click)="
                                                    uploadMalpractice(
                                                        application.id
                                                    )
                                                "
                                            >
                                                <fa-icon
                                                    [icon]="faUpload"
                                                ></fa-icon>
                                                Upload Malpractice
                                            </ion-button>
                                        </div> -->
                                    </div>
                                    <div *ngSwitchDefault>
                                        <ion-button
                                            *ngIf="!requirement?.Document.key"
                                            id="requirementbutton-{{ i }}"
                                            fill="clear"
                                            color="dark-teal"
                                            class="upload-btn"
                                            (click)="
                                                upload(
                                                    requirement?.jsondata?.type,
                                                    requirement?.applicationRequirementId,
                                                    requirement?.jsondata?.name,
                                                    i,
                                                    requirement?.level,
                                                    requirement?.levelid
                                                )
                                            "
                                        >
                                            <fa-icon [icon]="faUpload"></fa-icon>
                                            Upload document
                                        </ion-button>
                                        <ion-button
                                            *ngIf="requirement?.Document.key"
                                            id="requirementbutton-{{ i }}"
                                            fill="clear"
                                            color="dark-teal"
                                            class="upload-btn"
                                            (click)="
                                                downloadThenUploadModal(
                                                    requirement?.jsondata?.type,
                                                    requirement?.Document.key,
                                                    requirement?.Document.filename,
                                                    requirement?.jsondata?.name,
                                                    requirement?.jsondata?.name,
                                                    requirement?.jsondata?.usersubmission,
                                                    requirement?.applicationRequirementId,
                                                    requirement?.level,
                                                    requirement?.levelid
                                                )
                                            "
                                        >
                                            <fa-icon [icon]="faUpload"></fa-icon>
                                            Upload document
                                        </ion-button>
                                    </div>
                                </div>

                                <!-- ========== Requirement Upload Status Case ========== -->
                                <div [ngSwitch]="requirement?.jsondata?.type">
                                    <div *ngSwitchCase="'resume'">
                                        <ion-text (click)="viewDocument(requirement)" class="file-uploaded-text" *ngIf="profile?.resume">
                                            <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                            <span class="copy">{{ profile?.item1name }}</span>
                                        </ion-text>
                                    </div>
                                    <div *ngSwitchCase="'english'">
                                        <ion-text (click)="viewDocument(requirement)" class="file-uploaded-text" *ngIf="profile?.item10name">
                                            <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                            <span class="copy">{{ profile?.item10name }}</span>
                                        </ion-text>
                                    </div>

                                    <div *ngSwitchCase="'healthInsurance'"></div>

                                    <!-- MALPRACTICE CHECK -->

                                    <div *ngSwitchCase="'malpractice'">
                                        <div *ngFor="let application of handsOnApplications; let i = index">
                                            <div class="ion-margin-bottom ion-margin-top">
                                                <p class="copy ion-no-margin">
                                                    For Program:
                                                    {{ application?.Program?.name }}
                                                </p>
                                            </div>
                                            <ion-button
                                                *ngIf="!requirement?.Document.key"
                                                id="malpractice-upload-button-{{ i }}"
                                                fill="clear"
                                                color="dark-teal"
                                                class="upload-btn"
                                                (click)="uploadMalpractice(application.id)"
                                            >
                                                <fa-icon [icon]="faUpload"></fa-icon>
                                                Upload Malpractice
                                            </ion-button>

                                            <ion-text (click)="viewDocument(requirement, application.url)" class="file-uploaded-text" *ngIf="application.url">
                                                <div class="ion-margin-bottom">
                                                    <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                                    <span class="copy">{{ application.fileName }}</span>
                                                </div>
                                            </ion-text>

                                            <ion-button
                                                *ngIf="!application?.purchasedMalpracticeUrl && !application?.malpracticepaid"
                                                type="button"
                                                id="purchase-malpractice-button-{{ i }}"
                                                (click)="purchaseMalpractice(application?.id, application?.name)"
                                                [disabled]="applicationChainState !== 'Reserved' && applicationChainState !== 'Enrolled'"
                                                class="btn-link-button"
                                            >
                                                <fa-icon [icon]="faShoppingCart" class="button-icon" slot="start"></fa-icon>

                                                <ion-text class="ion-text-wrap bold sm-button-text">
                                                    {{ (toolService.content | async)?.application?.components?.generalDocuments?.health?.malpracticepurchase }}
                                                </ion-text>
                                            </ion-button>
                                            <ion-button
                                                (click)="viewMalpracticeFile(application?.purchasedMalpracticeUrl)"
                                                class="custom-document-button-complete btn-link-button"
                                                *ngIf="application?.purchasedMalpracticeUrl"
                                            >
                                                <fa-icon [icon]="faFile" slot="start"></fa-icon>

                                                <ion-text class="ion-text-wrap">
                                                    {{ (toolService.content | async)?.application?.components?.generalDocuments?.health?.viewmalpractice }}
                                                </ion-text>
                                            </ion-button>
                                            <div class="file-submitted-text" *ngIf="application?.malpracticepaid">
                                                <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                                <small>Malpractice Purchased</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngSwitchCase="'passport'">
                                        <ion-text (click)="viewDocument(requirement)" class="file-uploaded-text" *ngIf="profile?.item2name">
                                            <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                            <span class="copy">{{ profile?.item2name }}</span>
                                        </ion-text>
                                        <div *ngIf="!profile?.hasvisa && profile?.item2name" class="ion-margin-top">
                                            <ion-button
                                                fill="clear"
                                                color="dark-teal"
                                                class="upload-btn word-wrap"
                                                (click)="openPassportModal(chainedApplications[0].id)"
                                            >
                                                <fa-icon [icon]="faAlignLeft"></fa-icon>
                                                <span *ngIf="!profile?.hasvisa">
                                                    {{
                                                        (toolService.content | async)?.application?.components?.generalDocuments?.identity?.requestbutton
                                                    }}</span
                                                >
                                            </ion-button>
                                            <div>
                                                <ion-text class="file-submitted-text" *ngIf="profile?.passportnumber || profile?.passportform">
                                                    <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                                    <small>Passport Form Submitted</small>
                                                </ion-text>
                                            </div>
                                        </div>
                                        <div *ngFor="let file of downloadInvitationalLetters; let i = index">
                                            <ion-button
                                                fill="clear"
                                                id="download-invitation-letter-button-{{ i }}"
                                                color="dark-teal"
                                                class="upload-btn word-wrap"
                                                (click)="downloadInvitationLetter(file?.url)"
                                            >
                                                <fa-icon [icon]="faAlignLeft"></fa-icon>
                                                {{ (toolService.content | async)?.application?.components?.generalDocuments?.identity?.invitationdl }}
                                                - For Program: {{ file?.programid }}
                                            </ion-button>
                                        </div>
                                    </div>
                                    <div *ngSwitchCase="'education'">
                                        <ion-text (click)="viewDocument(requirement)" class="file-uploaded-text" *ngIf="profile?.item4name">
                                            <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                            <span class="copy">{{ profile?.item4name }}</span>
                                        </ion-text>
                                    </div>
                                    <div *ngSwitchCase="'immune'">
                                        <ion-text class="file-uploaded-text" *ngIf="profile?.immunizations.length > 0">
                                            <div *ngFor="let immune of profile?.immunizations; let i = index">
                                                <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                                <small
                                                    id="immunization-{{ i }}"
                                                    (click)="
                                                        viewDocument({
                                                            immunization: true,
                                                            file: immune
                                                        })
                                                    "
                                                    >{{ immune?.filename | decodeFileUrl }}</small
                                                >
                                            </div>
                                        </ion-text>
                                    </div>
                                    <div *ngSwitchCase="'visa'">
                                        <ion-text (click)="viewDocument(requirement)" class="file-uploaded-text" *ngIf="profile?.item7name">
                                            <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                            <small>{{ profile?.item7name }}</small>
                                        </ion-text>
                                    </div>
                                    <!-- <div *ngSwitchCase="'healthInsurance'">
                                        <ion-text (click)="viewDocument(requirement)" class="file-uploaded-text" *ngIf="profile?.item8name">
                                            <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                            <small>{{ profile?.item8name }}</small>
                                        </ion-text>
                                    </div> -->
                                    <div *ngSwitchCase="'housing'">
                                        <div *ngFor="let application of nonVirtualApplications; let i = index">
                                            <div>
                                                <ion-button
                                                    fill="clear"
                                                    id="housing-form-button-{{ i }}"
                                                    color="dark-teal"
                                                    class="upload-btn word-wrap housing-font"
                                                    (click)="openHousingModal(application?.id, application?.name, i)"
                                                >
                                                    <fa-icon [icon]="faAlignLeft"></fa-icon>
                                                    Submit Housing for
                                                    {{ application?.name }}
                                                </ion-button>
                                            </div>
                                            <ion-button
                                                *ngIf="!application.hashousing && showHousingCopyCheckboxes"
                                                id="copy-housing-button-{{ i }}"
                                                fill="clear"
                                                color="primary"
                                                (click)="copyHousing(application.id, i)"
                                            >
                                                <small>Use previous housing info</small>
                                            </ion-button>

                                            <div class="file-submitted-text" *ngIf="application?.hashousing">
                                                <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                                <small>Proof of Housing Submitted</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngSwitchDefault>
                                        <ion-text
                                            (click)="viewDocument(requirement)"
                                            class="file-uploaded-text"
                                            *ngIf="profile[requirement.applicationRequirementId]"
                                        >
                                            <fa-icon [icon]="faCheckCircle" class="doc-comp" size="medium"></fa-icon>
                                            <small>{{ requirement.jsondata.name }}.pdf</small>
                                        </ion-text>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ion-item>
        </ion-list>
    </ng-container>
</div>
